module.exports = __webpack_public_path__ + "img/ar.12952a7.webp";